import Cookies from 'js-cookie'
import Slick from 'vue-slick'
import KeenSlider from './keen-slider.vue'

export default {

    components: {
      Slick,
      KeenSlider
    }, 
  
    data: () => ({
      isHidden: false
    }),
  
    created () {
  
  
      
    if (this.getCookieValue() === 'hide') {
        this.hide()
    } else {
        this.show()
    }

  
    },
    methods: {

      getCookieValue (){
        return Cookies.get('announcement');
      },
  
      show (e) {
        this.isHidden = false
  
        Cookies.set('announcement', 'show', { expires: 30 })
      },
  
      hide () {
        this.isHidden = true
        const isCookieExists = Cookies.get('announcement');
        if(isCookieExists === 'show') {
          Cookies.set('announcement', 'hide', { expires: 30 })
        }
      }
    }
  }
  